import { connect } from 'react-redux';
import Downtime from './Downtime';

import './Downtime.css';

import { defaultActionsForMapDispatchToProps } from '../../utils/redux';

const mapStateToProps = state => ({
  messages: state.downtime.messages,
  loggedIn: state.auth.loggedIn
});
const defaultActions = {};
const mapDispatchToProps = defaultActionsForMapDispatchToProps(defaultActions);

export default connect(mapStateToProps, mapDispatchToProps)(Downtime);
